<template>
  <v-container>
    <h4>Xичээлийн тоо - багш бүрээр</h4>
    <v-data-table
      :loading="loading"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="teachers"
      :items-per-page="-1"
      show-expand
      class="elevation-1"
      ><template v-slot:item.sn="{ index }">
        {{ index + 1 }}
      </template>

      <template v-slot:item.avatar="{ item }">
        <v-avatar color="indigo" dark size="32"
          ><span class="white--text">{{
            item.name.substring(0, 2).toUpperCase()
          }}</span></v-avatar
        >
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td>
          <div
            :colspan="headers.length"
            v-for="(lesson, index) in item.lessons"
            :key="lesson.id"
          >
            {{ index + 1 }}. {{ lesson.name }}
            <span v-if="lesson.categoryData">
              <span
                class="badge badge-success"
                style="padding: 2px 4px 2px 4px; margin-right: 2px"
                v-if="lesson.categoryData.typeDetail.id == 'zaaval'"
                >ЗС</span
              >

              <span
                class="badge badge-warning"
                style="padding: 2px 4px 2px 4px; margin-right: 2px"
                v-else
                >СС</span
              >
            </span>
          </div>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import myfunction from "./../../global/myfunction.js";
const fb = require("../../../firebaseConfig.js");

export default {
  data() {
    return {
      teachers: [],
      headers: [
        {
          text: "#",
          value: "sn",
          width: "1%",
        },
        {
          text: "",
          value: "avatar",
        },
        { text: "Нэр", value: "name", align: "start", sortable: false },
        {
          text: "Овог",
          value: "lastname",
          align: "start",
          sortable: false,
        },
        { text: "Утас", value: "phone" },
        { text: "Имэйл", value: "email" },
        { text: "ЗАН", value: "sectorData.name" },
        { text: "Xичээлийн тоо", value: "lessons.length", align: "center" },
        { text: "", value: "data-table-expand" },
      ],

      lastVisible: null,
      loading: false,
      last: false,
      showSimple: true,
      searchValue: null,
      searched: false,
      searchField: "email",
      pageSize: 20,
      school: null,
      notconnected: 0,
      schoolId: "xUSN7smB3EcLwDYhs1Y9",
    };
  },

  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  mixins: [myfunction],
  methods: {
    async _getData() {
      var schoolDoc = await fb.db.doc("schools/" + this.schoolId).get();
      if (schoolDoc.exists) {
        let school = schoolDoc.data();
        school.id = schoolDoc.id;
        school.ref = schoolDoc.ref;
        this.school = school;
        this.teachers = [];
        this.getTeachers();
      }
    },

    async getTeachers() {
      this.loading = true;
      fb.db
        .collection("schools/" + this.schoolId + "/teachers")
        .orderBy("name", "asc")
        .get()
        .then((docs) => {
          this.teachers = [];
          docs.forEach(async (doc) => {
            let teacher = doc.data();
            teacher.id = doc.id;
            teacher.ref = doc.ref;
            teacher.sectorData = null;
            teacher.positionData = null;
            teacher.lessons = null;
            teacher.categoryData = null;

            if (teacher.user) {
              teacher.user.get().then(async (ddoc) => {
                teacher.userData = ddoc.data();
                teacher.userRef = ddoc.ref;
              });
            } else {
              //console.log(teacher.user)
            }

            if (teacher.sector) {
              teacher.sector.get().then((sdoc) => {
                teacher.sectorData = sdoc.data();
              });
            }
            // if (teacher.position) {
            //   teacher.position.get().then((sdoc) => {
            //     teacher.positionData = sdoc.data();
            //   });
            // }

            var query = fb.db
              .collection("schools/" + this.schoolId + "/lessons")
              .where("teacherRefs", "array-contains", teacher.ref);
            teacher.lessons = [];
            if (query != null) {
              var lessonsDatas = await query.get();

              for (const doc of lessonsDatas.docs) {
                let lesson = doc.data();
                lesson.id = doc.id;
                lesson.ref = doc.ref;
                if (
                  !(
                    lesson.deleted != null &&
                    lesson.deleted != undefined &&
                    lesson.deleted == true
                  )
                ) {
                  if (
                    lesson.year != undefined &&
                    lesson.year != null &&
                    lesson.year == 2021
                  ) {
                    if (
                      lesson.category != undefined &&
                      lesson.category != null
                    ) {
                      lesson.category.get().then((sdoc) => {
                        lesson.categoryData = sdoc.data();
                      });
                    }
                    teacher.lessons.push(lesson);
                  }
                }
              }
            }

            this.teachers.push(teacher);
          });
        });

      this.loading = false;
    },
    _edit(teacher) {
      this.$router.push({
        name: "TeacherAdd",
        params: { teacherId: teacher.id },
      });
    },
    search(value) {
      if (
        value != null &&
        value != "" &&
        this.searchField != null &&
        this.searchField != ""
      ) {
        this.lastVisible = null;
        this.last = false;
        this.searched = true;
        this.teachers = [];
        this.searchBy(value);
      }
    },
    async searchBy(value) {
      if (this.searchField == "code" || this.searchField == "email")
        value = value.toLowerCase();
      this.loading = true;
      var query;
      query = fb.db
        .collection("schools/" + this.schoolId + "/teachers")
        .where(this.searchField, "==", value);
      // if(this.schools!=null){
      //     query=query.where('school', "in", this.schools)
      // }

      if (query != null) {
        var documentSnapshots = await query.get();
        documentSnapshots.forEach((doc) => {
          let teacher = doc.data();
          teacher.id = doc.id;
          teacher.sectorData = null;
          teacher.positionData = null;

          if (teacher.user) {
            teacher.user.get().then((ddoc) => {
              teacher.userData = ddoc.data();
              teacher.userRef = ddoc.ref;
            });
          } else {
            //console.log(teacher.user)
          }
          if (teacher.sector) {
            teacher.sector.get().then((sdoc) => {
              teacher.sectorData = sdoc.data();
            });
          }

          if (teacher.position) {
            teacher.position.get().then((sdoc) => {
              teacher.positionData = sdoc.data();
            });
          }
          if (teacher.hide != true) this.teachers.push(teacher);
        });
      }
      this.loading = false;
    },
  },
  created() {
    this.teachers = [];
    this._getData();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
